import { Player } from '@lottiefiles/react-lottie-player'

const s3BucketUrl = 'https://pub-3fc85b9f90bf4cf39019f9387ceafd2a.r2.dev'

export function BadgeVip({ vipId }: { vipId: number }) {
  const endpoint = `${s3BucketUrl}/vips/${vipId}.json`

  if (vipId === 99) {
    return null
  }

  return (
    <div className="inline-flex h-5 w-11 shrink-0 items-center align-middle">
      <Player loop autoplay src={endpoint} className="h-5 w-11" />
    </div>
  )
}
